import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import utc from 'dayjs/plugin/utc'
import dayjs from 'dayjs'
import en from './translations/en'
import sv from './translations/sv'
import fi from './translations/fi'
import { getLanguageOption } from '../helpers/i18n'
import 'dayjs/locale/sv'
import 'dayjs/locale/en'
import 'dayjs/locale/fi'
import { ISocietiesModel } from '../interfaces/models/societies.interfaces'

export const resources = {
  sv: {
    translation: sv,
  },
  en: {
    translation: en,
  },
  fi: {
    translation: fi,
  },
} as const

i18n.use(initReactI18next).init({
  lng: 'sv',
  fallbackLng: 'sv',
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources,
})

dayjs.locale(getLanguageOption(i18n.language).dateFns)
dayjs.extend(utc)

export const i18nSocietyType = (
  societyTypeDisplayName?: ISocietiesModel['societyTypeDisplayName'] | string
): 'brf' | 'samf' | 'lgh' => {
  switch (societyTypeDisplayName) {
    case 'homeowners_association':
    case 'non_profit_association':
    case 'economic_association':
      return 'samf'
    case 'housing_cooperative':
      return 'brf'
    case 'apartment_building':
      return 'lgh'
    default:
      return 'brf'
  }
}
export default i18n
